import RealPusher from 'pusher-js/with-encryption';
import MockPusher from 'mocks/mock-pusher';

const mswEnabled = import.meta.env.VITE_ENABLE_MSW;
const Pusher = mswEnabled ? MockPusher : RealPusher;

let client;

const { key, cluster } = window.CONFIG?.pusher ?? {};

// In MSW mode, always create client (MockPusher doesn't need real credentials)
if (key || mswEnabled) {
  client = new Pusher(key, { cluster });
} else {
  console.warn('Pusher is not configured.');
}

const NOOP = function () {};

const fakeChannel = {
  bind: NOOP,
  unbind: NOOP,
  unsubscribe: NOOP,
};

export function subscribe(...args) {
  if (client) {
    return client.subscribe(...args);
  } else {
    return fakeChannel;
  }
}
